import userResponseConfig, { AlmeUserResponseConfig } from './AlmeUserResponse/AlmeUserResponseConfig';
import ivaResponseConfig, { AlmeIvaResponseConfig } from './AlmeIvaResponse/AlmeIvaResponseConfig';

interface ResponseConfig extends AlmeUserResponseConfig, AlmeIvaResponseConfig {
}

export interface AlmeResponseConfig {
    response: ResponseConfig;
}

/**
 * This is the baseline response config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeResponseConfig = {
    response: {
        ...userResponseConfig,
        ...ivaResponseConfig,
    },
};

export default defaultConfig;